module.exports = ".active {\r\n    display: none;\r\n}\r\n\r\nul {\r\n    list-style-type: none;\r\n}\r\n\r\nli {\r\n    border: 1px solid black;\r\n    border-radius: 5px;\r\n    text-align: center;\r\n}\r\n\r\n.li1 {\r\n    margin: 5px;\r\n    width: 60px;\r\n    padding: 3px;\r\n}\r\n\r\n.li2 {\r\n    margin: 5px;\r\n    width: 100px;\r\n    padding: 3px;\r\n}\r\n\r\n.li3 {\r\n    margin: 5px;\r\n    width: 80px;\r\n    padding: 3px;\r\n}\r\n\r\n.nav-item:hover {\r\n    background-color: yellow;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.css
// module id = ./src/app/header/header.component.css
// module chunks = main